import { useContext, useEffect, useState } from "react";
import useLocalStorage from "../../Utility/useLocalStorage";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import CardHome from "../../Components/CardHome";

const cards = [
  {
    id: 1,
    titolo: "INTERVENTI",
    descrizione:
      "Potrai visualizzare tutti gli interventi disponibili e filtrarli per categoria",
    badge: 0,
    link: "/lista_interventi",
  },
  {
    id: 2,
    titolo: "UTENTI",
    descrizione:
      "Potrai visualizzare tutti gli utenti presenti nella  piattaforma, inserirne nuovi e caricare per loro l'Isee",
    badge: 0,
    link: "/lista_utenti",
  },
  {
    id: 3,
    titolo: "ISCRIZIONI",
    descrizione:
      "Potrai visualizzare tutte le iscrizioni nuove e visualizzarne i dettagli",
    badge: 0,
    link: "/iscrizioni",
  },
];

function HomeDelegate(props) {
  const [ISEEList, setISEEList] = useState();
  const [cardsState, setCardsState] = useState([]);
  const apiToken = useContext(TokenContext);
  const [loadedUser, setLoadedUser] = useState();
  //
  //setCardsState(cards);

  useEffect(() => {
    Repo.getUsersLoadedCount(apiToken)
      .then((response) => {
        setLoadedUser(parseInt(response.data));

        if (parseInt(response.data) > 0) {
          let e2 = cards.map((item) => {
            if (item.id === 2) {
              (item.badge = parseInt(response.data)),
                (item.link = "/lista_utenti?loaded=true");
            }
            return;
            item;
          });

          setCardsState(e2);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    Repo.getSubscriptionNewCount(apiToken)
      .then((response) => {
        if (parseInt(response.data) > 0) {
          let e3 = cards.map((item) => {
            if (item.id === 3) {
              (item.badge = parseInt(response.data)),
                (item.link = "/iscrizioni?loaded=true");
            }
            return;
          });
          setCardsState(e3);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <h1>Pannello operatore comunale</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Riepilogo delle principali funzioni di{" "}
          <strong>Semplícita Ambiti Territoriali Sociali</strong>
        </p>
      </div>
      <div className="row">{cards.map(CardHome)}</div>
    </>
  );
}

export default HomeDelegate;
